import { Component, OnInit, Inject, Optional, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatStepper } from '@angular/material';
import { FormGroup, FormControl, FormArray, FormBuilder, Validators } from '@angular/forms';
import { CommonHelper } from '../../../../utilities/common.helper';
import { Router } from '@angular/router';
import { HEC_CONSTANTS } from '../../../../utilities/constants';

@Component({
  selector: 'kt-questionnaire',
  templateUrl: './questionnaire.component.html',
  styleUrls: ['./questionnaire.component.css']
})
export class QuestionnaireComponent implements OnInit {
  isLinear = true;
  @ViewChild('stepper',{static:false}) stepper: MatStepper;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  public questionsList:any=[];
  public questionnaireForm: FormGroup;
  public selectionQuestionnairAnswer:any=[];
  public showError:boolean = false;
  public acryonym:string;
  public isBScNursing:boolean = false;
  public isDiplomaNursing:boolean = false;
  public isHomeEcomnomics:boolean = false;
  public onCampusDegree:boolean = false;
  public passportAvailable:boolean = false;
  public showWarning:boolean = false;
  constructor(private dialogRef: MatDialogRef<QuestionnaireComponent>, private fb: FormBuilder,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,private router:Router) { }

  ngOnInit() {
    this.firstFormGroup = this.fb.group({
      firstCtrl: ['', Validators.required]
    });
    this.secondFormGroup = this.fb.group({
      secondCtrl: ['', Validators.required]
    });
  
    this.questionsList = this.data.questions;
    this.acryonym = this.data.acryonym
    this.createQuestionnaireForm();
    for(let i=0; i< this.questionsList.length;i++){
      this.addNewQuestionnaire(this.questionsList[i]);
    }

  }


  private createQuestionnaireForm(): void {
    this.questionnaireForm = this.fb.group({
      questionnaireDtoList: this.fb.array([]),
    })
  }

  public getQuestionnaireList(): any {
    return this.questionnaireForm.controls.questionnaireDtoList['controls'];
  }

  public addNewQuestionnaire(data): void {
    const eduValues = this.questionnaireForm.controls.questionnaireDtoList as FormArray;
    let newRow = this.fb.group({
      isChecked: new FormControl(null,[Validators.required]),
      questionId: new FormControl(data.id ? data.id : null),

    });
    eduValues.push(newRow);
  }

  public getRadioSelection(event,index){
    this.selectionQuestionnairAnswer[index] = event.value;
    if(this.router.url == HEC_CONSTANTS.DES_URLS.LOCAL_DES){
    if(index == 5){
      this.isBScNursing = event.value
    }
    
    if(index == 6){
      this.isHomeEcomnomics = event.value
    }

    if(index == 7){
      this.isDiplomaNursing = event.value
    }
  }else if(this.router.url == HEC_CONSTANTS.DES_URLS.FOREIGN_DES){
    if(index == 5){
      this.onCampusDegree = event.value;
    } 
    if(index == 6){
      this.passportAvailable = event.value;
    }
  }
  }

  moveToNextTab(index){
    if(this.router.url == HEC_CONSTANTS.DES_URLS.LOCAL_DES){

    if(this.selectionQuestionnairAnswer[index] && index <5){
    this.stepper.next()
    }
    else if(this.selectionQuestionnairAnswer[index] != undefined && index >4 && !this.selectionQuestionnairAnswer[index]){
      this.stepper.next()
    }
    else if(this.selectionQuestionnairAnswer[index] != undefined && index >4 && this.selectionQuestionnairAnswer[index]){
      this.dialogRef.close({isQuesionnaire:true,isDiplomaNursing:this.isDiplomaNursing,isBScNursing:this.isBScNursing,isHomeEcomnomics:this.isHomeEcomnomics});

    }else if(!this.selectionQuestionnairAnswer[index] && index <5){
      this.showError = true;
    }
  }else if(this.router.url == HEC_CONSTANTS.DES_URLS.FOREIGN_DES){
    if(this.selectionQuestionnairAnswer[index]){
      this.stepper.next()
    }
    else if(!this.selectionQuestionnairAnswer[index] && index == 5){
    // this.showWarning = true
    this.dialogRef.close({isQuesionnaire:true,onCampusDegree:this.onCampusDegree,passportAvailable:this.passportAvailable});
    }
    else if(!this.selectionQuestionnairAnswer[index] && index <5){
      this.showError = true;
    }    
  }else{
    if(this.selectionQuestionnairAnswer[index] && index <5){
      this.stepper.next()
    }
    else if(!this.selectionQuestionnairAnswer[index] && index <5){
      this.showError = true;
    }
  }
   }
  
   moveToPrvTab(){
     
   this.stepper.previous();
  }

  public markFormsTouched(form): void {
    CommonHelper.markFormGroupTouched(form);
  }

  public onButtonClose(){
    this.dialogRef.close();
  }

  public onButtonSubmit(index){
    // if(this.selectionQuestionnairAnswer[index]){
    //   this.stepper.next()
    //   }else{
    //     this.showError = true;
    //   }
    if(this.selectionQuestionnairAnswer[index] && index <5){
      this.stepper.next()
      }
      else if(this.selectionQuestionnairAnswer[index] != undefined && index >4){
        this.stepper.next()
      }else{
            this.showError = true;
          }
    if(this.router.url == HEC_CONSTANTS.DES_URLS.LOCAL_DES){
      if(!this.showError){
        this.dialogRef.close({isQuesionnaire:true,isDiplomaNursing:this.isDiplomaNursing,isBScNursing:this.isBScNursing,isHomeEcomnomics:this.isHomeEcomnomics});

      }
      }else if(this.router.url == HEC_CONSTANTS.DES_URLS.FOREIGN_DES){
        if(!this.selectionQuestionnairAnswer[index] && index == 6){
        this.showWarning = true
        setTimeout(()=>{
          // this.stepper.next()
           if(!this.showError){
          this.dialogRef.close({isQuesionnaire:true,onCampusDegree:this.onCampusDegree,passportAvailable:this.passportAvailable});
        }
        this.showWarning = false;
        },2000)
      }else {
        if(!this.showError){
          this.dialogRef.close({isQuesionnaire:true,onCampusDegree:this.onCampusDegree,passportAvailable:this.passportAvailable});
  
        }
      }
       
      }else{
        if(!this.showError){
        this.dialogRef.close(true)
        }
      }
  }


}
